import React from 'react'
import { Route } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { getLoggedInUserInfo, hasFeatureAccess } from 'utils'

const ProtectedRoute = ({ routerAnimation, Component, modules = [], permission, ...rest }) => {
  const userInfo = getLoggedInUserInfo()
  const userRole = userInfo?.userRole
  const userRoles = userInfo?.userRoles || {}

  let isAuthenticated = false

  // Allow public routes without restriction
  const publicPaths = [
    'reset-password',
    'candidate-form',
    'auth/login',
    'auth/register',
    'projects-module-master',
  ]
  const isPublicRoute = publicPaths.some((path) => rest.path.includes(path))

  if (isPublicRoute) {
    isAuthenticated = true
  }

  // Super Admin bypasses all checks
  if (userRole === 'super_admin') {
    isAuthenticated = true
  }

  // Check access via feature utility
  if (!isAuthenticated && Array.isArray(modules) && modules.length > 0) {
    isAuthenticated = modules.some((module) => hasFeatureAccess(module, permission))
  }

  // Optional fallback: legacy userRoles check if feature check fails
  if (!isAuthenticated && !isEmpty(userRoles)) {
    isAuthenticated = modules.some((module) => {
      if (permission) {
        return userRoles[module]?.includes(permission)
      }
      return Object.prototype.hasOwnProperty.call(userRoles, module)
    })
  }

  return (
    <Route
      {...rest}
      render={
        () => (
          // isAuthenticated ? (
          <div className={routerAnimation}>
            {/* <Suspense fallback={null}> */}
            <Component />
            {/* </Suspense> */}
          </div>
        )
        // ) : (
        //   <Redirect to="/auth/404" />
        // )
      }
    />
  )
}

export default ProtectedRoute
